// extracted by mini-css-extract-plugin
export default {"container":"Templates_container__eI8V1"};